import React from 'react';
import {useDispatch, useSelector} from 'react-redux';

import configService from '../../../../services/ConfigService';

import {configActions, configSelectors} from '../../Config';


function useGeoConfig() {

    const isGeoConfigLoaded = useSelector(configSelectors.isGeoConfigLoaded);
    const isGeoConfigLoading = useSelector(configSelectors.isGeoConfigLoading);
    const dispatch = useDispatch();
    const geoConfig = useSelector(configSelectors.getGeoConfig);

    if (!isGeoConfigLoaded && !isGeoConfigLoading) {

        dispatch(configActions.onGeoConfigLoading(geoConfig));

        (async () => {
            const geoConfig = await configService.loadGeoConfig();
            dispatch(configActions.onGeoConfigLoaded(geoConfig));
        })();
    }

    return {
        ...geoConfig,
        isGeoConfigLoaded,
        isGeoConfigLoading
    };
}


export default useGeoConfig;
